<!-- filter-condition-input.component.html -->
<div class="value-input">
    <ng-container [ngSwitch]="selectedFieldType">
        <!-- Text fields -->
        <ng-container *ngSwitchCase="fieldTypes.SINGLE_LINE_TEXT">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.SINGLE_LINE_TEXT" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>
        
        <ng-container *ngSwitchCase="fieldTypes.MULTI_LINE_TEXT">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.SINGLE_LINE_TEXT" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>
        
        <ng-container *ngSwitchCase="fieldTypes.RICH_TEXT">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.SINGLE_LINE_TEXT" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>
        
        <ng-container *ngSwitchCase="fieldTypes.EMAIL">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.SINGLE_LINE_TEXT" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>
        
        <ng-container *ngSwitchCase="fieldTypes.PHONE">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.SINGLE_LINE_TEXT" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>

        <!-- Number fields -->
        <ng-container *ngSwitchCase="fieldTypes.NUMBER">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="selectedFieldType" 
                (inputValueChange)="updateValue($event)" 
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>

        <!-- Date fields -->
        <ng-container *ngSwitchCase="fieldTypes.DATE">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.DATE" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>
        
        <ng-container *ngSwitchCase="fieldTypes.DATE_AND_TIME">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.DATE" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>

        <!-- Checkbox fields -->
        <ng-container *ngSwitchCase="fieldTypes.CHECKBOX">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="selectedFieldType" 
                [hideEmptyOption]="true" 
                (inputValueChange)="updateValue($event)"
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>

        <!-- User fields -->
        <ng-container *ngSwitchCase="fieldTypes.USER">
            <app-user-input 
                [allUsers]="allUsers" 
                [value]="value" 
                [canMultiSelect]="true" 
                [showLabel]="false" 
                [showCurrentUserOption]="true" 
                (valueChange)="updateValue($event)">
            </app-user-input>
        </ng-container>

        <!-- Selection fields -->
        <ng-container *ngSwitchCase="fieldTypes.DROPDOWN">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.MULTI_SELECT_DROPDOWN" 
                [options]="options" 
                (inputValueChange)="updateValue($event)" 
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>
        
        <ng-container *ngSwitchCase="fieldTypes.MULTI_SELECT_DROPDOWN">
            <app-global-input 
                [showLabel]="false" 
                [value]="value" 
                [field_type]="fieldTypes.MULTI_SELECT_DROPDOWN" 
                [options]="options" 
                (inputValueChange)="updateValue($event)" 
                (invalidateField)="onInvalidateField($event)">
            </app-global-input>
        </ng-container>

        <!-- Default text input for other types -->
        <ng-container *ngSwitchDefault>
            <ym-input 
                [showLabel]="false" 
                placeholder="Enter value" 
                [value]="value" 
                (valueChange)="updateValue($event)">
            </ym-input>
        </ng-container>
    </ng-container>
</div>